export default __webpack_public_path__ + "static/3_29-4e6fccc8e04b8d0e3af2c38f3009b5f2.png";